<template>
  <div class="container mt-1">
    <div class="row">
      <div class="col">
        <button
          class="btn btn-sm btn-primary float-start padding2"
          @click="toggleFlash()"
        >
          Flash
        </button>
        <!-- {{ unsold }} -->
      </div>
    </div>
    <div class="row" v-if="auction.flash_auction">
      <div class="col">
        <FlashPoolist></FlashPoolist>
      </div>
    </div>
  </div>
</template>
<script setup>
import supabase from "@/supabase/config";
import { onMounted, ref, computed } from "vue";
import { useStore } from "@/store/index";
import FlashPoolist from "./FlashPoolist.vue";
const auction = ref({});
const unsold_players = ref([]);
const unsold_bids = ref();
const store = useStore();

onMounted(() => {
  setTimeout(() => {
    fetchAuction();
    fetchUnsoldPlayers();
    fetchBids();
  }, 1000);
});
const fetchBids = async () => {
  let { data: bids, error } = await supabase
    .from("bids")
    .select("*")
    .eq("auction_id", store.live_auction);
  unsold_bids.value = bids;
  store.setUnsoldBids(unsold_bids.value);
  setupBidsListner();
  setupBidsDeleteListner();
};
const setupBidsListner = () => {
  const channels = supabase
    .channel("unsold-bids-custom-filter-channel")
    .on(
      "postgres_changes",
      {
        event: "*",
        schema: "public",
        table: "bids",
        filter: `auction_id=eq.${store.live_auction}`,
      },
      (payload) => {
        if (payload.eventType == "INSERT") {
          store.addToUnsoldBids(payload.new);
        }
        //console.log("Change received!", payload);
      }
    )
    .subscribe();
};
const setupBidsDeleteListner = () => {
  const channels = supabase
    .channel("unsold-bids-custom-delete-channel")
    .on(
      "postgres_changes",
      { event: "DELETE", schema: "public", table: "bids" },
      (payload) => {
        store.removeFromUnsoldBids(payload.old.id);
        //console.log("DELETE Change received!", payload);
      }
    )
    .subscribe();
};
const fetchAuction = async () => {
  let { data: auctions, error } = await supabase
    .from("auctions")
    .select("*")
    .eq("id", store.live_auction);
  auction.value = auctions[0];
  setupAuctionListner();
};
const fetchUnsoldPlayers = async () => {
  let { data: players, error } = await supabase
    .from("players")
    .select("*")
    .is("team_id", null)
    .eq("auction_id", store.live_auction);
  unsold_players.value = players;
  store.setUnsoldPlayers(unsold_players.value);
  setupUnsoldPlayersListner();
};
const setupUnsoldPlayersListner = () => {
  const channels = supabase
    .channel("flash-unsold-players-custom-filter-channel")
    .on(
      "postgres_changes",
      {
        event: "*",
        schema: "public",
        table: "players",
        filter: `auction_id=eq.${store.live_auction}`,
      },
      (payload) => {
        var new_data = payload.new;
        if (new_data.team_id) {
          store.removeFromUnsold(new_data.id);
        } else {
          store.addToUnsold(new_data);
        }
      }
    )
    .subscribe();
};
const setupAuctionListner = () => {
  const channels = supabase
    .channel("flash-auction-listner-filter-channel")
    .on(
      "postgres_changes",
      {
        event: "*",
        schema: "public",
        table: "auctions",
        filter: `id=eq.${store.live_auction}`,
      },
      (payload) => {
        console.log("Change received!", payload, payload.eventType);
        if (payload.eventType === "UPDATE") {
          auction.value = payload.new;
        }
      }
    )
    .subscribe();
};
const toggleFlash = async () => {
  const { data, error } = await supabase
    .from("auctions")
    .update({ flash_auction: !auction.value.flash_auction })
    .eq("id", store.live_auction)
    .select();
};
const unsold = computed(() => {
  return store.unsold_bids;
});
</script>

<style scoped>
.padding2 {
  padding: 2px;
}
</style>
